import { render, staticRenderFns } from "./BaseUserField.vue?vue&type=template&id=5fd7779c&scoped=true&lang=pug&"
import script from "./BaseUserField.vue?vue&type=script&lang=js&"
export * from "./BaseUserField.vue?vue&type=script&lang=js&"
import style0 from "./BaseUserField.vue?vue&type=style&index=0&id=5fd7779c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd7779c",
  null
  
)

export default component.exports